// Generated by purs version 0.15.16
import * as API_Autofill from "../API.Autofill/index.js";
import * as App_Operation_Types from "../App.Operation.Types/index.js";
import * as App_Route from "../App.Route/index.js";
import * as App_Step from "../App.Step/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Steps_Step3_State from "../Steps.Step3.State/index.js";
import * as Steps_Step3_Transition from "../Steps.Step3.Transition/index.js";
import * as Steps_Step3_Types from "../Steps.Step3.Types/index.js";
import * as Steps_WorkQueue_View from "../Steps.WorkQueue.View/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var eqMaybe = /* #__PURE__ */ Data_Maybe.eqMaybe(App_Operation_Types.eqOperationId);
var eq = /* #__PURE__ */ Data_Eq.eq(eqMaybe);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var notEq = /* #__PURE__ */ Data_Eq.notEq(eqMaybe);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var oneOf = /* #__PURE__ */ Data_Foldable.oneOf(Data_Foldable.foldableArray)(Data_Maybe.plusMaybe);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var ViewEvent = /* #__PURE__ */ (function () {
    function ViewEvent(value0) {
        this.value0 = value0;
    };
    ViewEvent.create = function (value0) {
        return new ViewEvent(value0);
    };
    return ViewEvent;
})();
var ConfirmCancelResult = /* #__PURE__ */ (function () {
    function ConfirmCancelResult(value0) {
        this.value0 = value0;
    };
    ConfirmCancelResult.create = function (value0) {
        return new ConfirmCancelResult(value0);
    };
    return ConfirmCancelResult;
})();
var SaveCompleted = /* #__PURE__ */ (function () {
    function SaveCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SaveCompleted.create = function (value0) {
        return function (value1) {
            return new SaveCompleted(value0, value1);
        };
    };
    return SaveCompleted;
})();
var LoadCompleted = /* #__PURE__ */ (function () {
    function LoadCompleted(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    LoadCompleted.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new LoadCompleted(value0, value1, value2);
            };
        };
    };
    return LoadCompleted;
})();
var AutofillCompleted = /* #__PURE__ */ (function () {
    function AutofillCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AutofillCompleted.create = function (value0) {
        return function (value1) {
            return new AutofillCompleted(value0, value1);
        };
    };
    return AutofillCompleted;
})();
var LockCompleted = /* #__PURE__ */ (function () {
    function LockCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    LockCompleted.create = function (value0) {
        return function (value1) {
            return new LockCompleted(value0, value1);
        };
    };
    return LockCompleted;
})();
var DocumentMutationCompleted = /* #__PURE__ */ (function () {
    function DocumentMutationCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DocumentMutationCompleted.create = function (value0) {
        return function (value1) {
            return new DocumentMutationCompleted(value0, value1);
        };
    };
    return DocumentMutationCompleted;
})();
var SyncRoute = /* #__PURE__ */ (function () {
    function SyncRoute(value0) {
        this.value0 = value0;
    };
    SyncRoute.create = function (value0) {
        return new SyncRoute(value0);
    };
    return SyncRoute;
})();
var StartSave = /* #__PURE__ */ (function () {
    function StartSave(value0) {
        this.value0 = value0;
    };
    StartSave.create = function (value0) {
        return new StartSave(value0);
    };
    return StartSave;
})();
var StartLoad = /* #__PURE__ */ (function () {
    function StartLoad(value0) {
        this.value0 = value0;
    };
    StartLoad.create = function (value0) {
        return new StartLoad(value0);
    };
    return StartLoad;
})();
var StartAutofill = /* #__PURE__ */ (function () {
    function StartAutofill(value0) {
        this.value0 = value0;
    };
    StartAutofill.create = function (value0) {
        return new StartAutofill(value0);
    };
    return StartAutofill;
})();
var StartToggleLock = /* #__PURE__ */ (function () {
    function StartToggleLock() {

    };
    StartToggleLock.value = new StartToggleLock();
    return StartToggleLock;
})();
var StartDocumentMutation = /* #__PURE__ */ (function () {
    function StartDocumentMutation(value0) {
        this.value0 = value0;
    };
    StartDocumentMutation.create = function (value0) {
        return new StartDocumentMutation(value0);
    };
    return StartDocumentMutation;
})();
var ConfirmCancel = /* #__PURE__ */ (function () {
    function ConfirmCancel() {

    };
    ConfirmCancel.value = new ConfirmCancel();
    return ConfirmCancel;
})();
var AllowPageUnload = /* #__PURE__ */ (function () {
    function AllowPageUnload() {

    };
    AllowPageUnload.value = new AllowPageUnload();
    return AllowPageUnload;
})();
var BlockPageUnload = /* #__PURE__ */ (function () {
    function BlockPageUnload() {

    };
    BlockPageUnload.value = new BlockPageUnload();
    return BlockPageUnload;
})();
var OpenExportUrl = /* #__PURE__ */ (function () {
    function OpenExportUrl(value0) {
        this.value0 = value0;
    };
    OpenExportUrl.create = function (value0) {
        return new OpenExportUrl(value0);
    };
    return OpenExportUrl;
})();
var Navigate = /* #__PURE__ */ (function () {
    function Navigate(value0) {
        this.value0 = value0;
    };
    Navigate.create = function (value0) {
        return new Navigate(value0);
    };
    return Navigate;
})();
var MarkSuperseded = /* #__PURE__ */ (function () {
    function MarkSuperseded(value0) {
        this.value0 = value0;
    };
    MarkSuperseded.create = function (value0) {
        return new MarkSuperseded(value0);
    };
    return MarkSuperseded;
})();
var lookupTransitionTarget = function (lookup) {
    return function (section) {
        return function (state) {
            return map(function (idx) {
                return {
                    idx: idx,
                    section: section
                };
            })(Data_Array.findIndex(Steps_Step3_Types.matchesLookup(lookup))(state.editor.queue));
        };
    };
};
var clearIfMatches = function (opId) {
    return function (current) {
        var $62 = eq(current)(new Data_Maybe.Just(opId));
        if ($62) {
            return Data_Maybe.Nothing.value;
        };
        return current;
    };
};
var clearLoadOperation = function (opId) {
    return function (state) {
        return {
            editor: state.editor,
            saveOperationId: state.saveOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            loadOperationId: clearIfMatches(opId)(state.loadOperationId)
        };
    };
};
var captureTransitionDuringBusy = function (state) {
    return function (event) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: Steps_Step3_Types.captureTransitionIntent(state.editor)(event)
        };
    };
};
var continuePendingTransition = function (state) {
    return function (target) {
        return function (prefixCommands) {
            if (target.position === state.editor.position) {
                var nextEditor = {
                    fillState: state.editor.fillState,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: state.editor.workQueueUi,
                    anchor: Data_Maybe.Nothing.value,
                    activeSection: target.anchor,
                    sectionIntent: Data_Maybe.maybe(App_Route.SectionClear.value)(App_Route.SectionSet.create)(target.anchor)
                };
                var v = Steps_Step3_Transition.finishTransition(nextEditor.transitionState)(target.generation);
                var settledState = {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: state.saveOperationId,
                    editor: {
                        activeSection: nextEditor.activeSection,
                        anchor: nextEditor.anchor,
                        fillState: nextEditor.fillState,
                        position: nextEditor.position,
                        queue: nextEditor.queue,
                        sectionIntent: nextEditor.sectionIntent,
                        workQueueCache: nextEditor.workQueueCache,
                        workQueueState: nextEditor.workQueueState,
                        workQueueUi: nextEditor.workQueueUi,
                        transitionState: v.value1
                    }
                };
                var commands = append(prefixCommands)([ new SyncRoute(target.historyMode) ]);
                if (v.value0) {
                    return pure({
                        state: settledState,
                        commands: commands
                    });
                };
                return beginPendingTransition(settledState);
            };
            if (Data_Maybe.isJust(state.saveOperationId) || Data_Maybe.isJust(state.loadOperationId)) {
                return pure({
                    state: state,
                    commands: prefixCommands
                });
            };
            if (Steps_Step3_State.shouldSaveCurrentDocument(state)) {
                return pure({
                    state: state,
                    commands: append(prefixCommands)([ new StartSave(new Data_Maybe.Just(target.generation)) ])
                });
            };
            if (Data_Boolean.otherwise) {
                return pure({
                    state: state,
                    commands: append(prefixCommands)([ new StartLoad(target) ])
                });
            };
            throw new Error("Failed pattern match at Steps.Step3.Update (line 338, column 1 - line 338, column 114): " + [ state.constructor.name, target.constructor.name, prefixCommands.constructor.name ]);
        };
    };
};
var beginPendingTransition = function (state) {
    var v = Steps_Step3_Transition.latestTransition(state.editor.transitionState);
    if (v instanceof Data_Maybe.Nothing) {
        return pure({
            state: state,
            commands: [  ]
        });
    };
    if (v instanceof Data_Maybe.Just) {
        return continuePendingTransition(state)(v.value0)([  ]);
    };
    throw new Error("Failed pattern match at Steps.Step3.Update (line 332, column 32 - line 336, column 50): " + [ v.constructor.name ]);
};
var requestTransition = function (v) {
    return function (v1) {
        if (v1 instanceof Data_Maybe.Nothing) {
            return pure({
                state: v,
                commands: [  ]
            });
        };
        if (v1 instanceof Data_Maybe.Just) {
            var v2 = Steps_Step3_Transition.enqueueTransition(v.editor.transitionState)(v1.value0.idx)(v1.value0.section);
            var queuedState = Steps_Step3_State.mapEditorState(function (editor) {
                return {
                    queue: editor.queue,
                    position: editor.position,
                    anchor: editor.anchor,
                    activeSection: editor.activeSection,
                    sectionIntent: editor.sectionIntent,
                    workQueueState: editor.workQueueState,
                    workQueueUi: editor.workQueueUi,
                    workQueueCache: editor.workQueueCache,
                    fillState: editor.fillState,
                    transitionState: v2.value1
                };
            })(v);
            if (v2.value0) {
                return beginPendingTransition(queuedState);
            };
            return pure({
                state: queuedState,
                commands: [  ]
            });
        };
        throw new Error("Failed pattern match at Steps.Step3.Update (line 319, column 1 - line 322, column 40): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var update = function (state) {
    return function (v) {
        if (v instanceof ConfirmCancelResult) {
            return pure({
                state: state,
                commands: (function () {
                    if (v.value0) {
                        return [ new Navigate(App_Step.NavCancel.value) ];
                    };
                    return [  ];
                })()
            });
        };
        if (v instanceof SaveCompleted && notEq(state.saveOperationId)(new Data_Maybe.Just(v.value0))) {
            return pure({
                state: state,
                commands: [  ]
            });
        };
        if (v instanceof SaveCompleted) {
            return bind((function () {
                if (v.value1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(v.value1.value0);
                };
                if (v.value1 instanceof Data_Either.Right) {
                    return Data_Function.flip(Steps_Step3_State.applySavedDocumentState)(v.value1.value0)({
                        editor: state.editor,
                        loadOperationId: state.loadOperationId,
                        autofillOperationId: state.autofillOperationId,
                        lockOperationId: state.lockOperationId,
                        documentMutationOperationId: state.documentMutationOperationId,
                        pendingPostSave: state.pendingPostSave,
                        saveOperationId: clearIfMatches(v.value0)(state.saveOperationId)
                    });
                };
                throw new Error("Failed pattern match at Steps.Step3.Update (line 73, column 22 - line 78, column 22): " + [ v.value1.constructor.name ]);
            })())(function (nextState) {
                var afterSaveState = {
                    autofillOperationId: nextState.autofillOperationId,
                    documentMutationOperationId: nextState.documentMutationOperationId,
                    editor: nextState.editor,
                    loadOperationId: nextState.loadOperationId,
                    lockOperationId: nextState.lockOperationId,
                    saveOperationId: nextState.saveOperationId,
                    pendingPostSave: Data_Maybe.Nothing.value
                };
                var baseCommands = [ AllowPageUnload.value ];
                var v1 = Steps_Step3_Transition.latestTransition(afterSaveState.editor.transitionState);
                if (v1 instanceof Data_Maybe.Just) {
                    return continuePendingTransition(afterSaveState)(v1.value0)(baseCommands);
                };
                if (v1 instanceof Data_Maybe.Nothing) {
                    return pure({
                        state: afterSaveState,
                        commands: append(baseCommands)((function () {
                            if (nextState.pendingPostSave instanceof Data_Maybe.Nothing) {
                                return [  ];
                            };
                            if (nextState.pendingPostSave instanceof Data_Maybe.Just && nextState.pendingPostSave.value0 instanceof Steps_Step3_State.SaveThenCancel) {
                                return [ new Navigate(App_Step.NavCancel.value) ];
                            };
                            if (nextState.pendingPostSave instanceof Data_Maybe.Just && nextState.pendingPostSave.value0 instanceof Steps_Step3_State.SaveThenFinish) {
                                return [ new Navigate(App_Step.NavNext.value) ];
                            };
                            if (nextState.pendingPostSave instanceof Data_Maybe.Just && nextState.pendingPostSave.value0 instanceof Steps_Step3_State.SaveThenExport) {
                                return [ new OpenExportUrl(nextState.pendingPostSave.value0.value0.url) ];
                            };
                            if (nextState.pendingPostSave instanceof Data_Maybe.Just && nextState.pendingPostSave.value0 instanceof Steps_Step3_State.SaveThenLock) {
                                return [ StartToggleLock.value ];
                            };
                            throw new Error("Failed pattern match at Steps.Step3.Update (line 87, column 49 - line 92, column 65): " + [ nextState.pendingPostSave.constructor.name ]);
                        })())
                    });
                };
                throw new Error("Failed pattern match at Steps.Step3.Update (line 81, column 9 - line 93, column 22): " + [ v1.constructor.name ]);
            });
        };
        if (v instanceof LoadCompleted && notEq(state.loadOperationId)(new Data_Maybe.Just(v.value0))) {
            return pure({
                state: state,
                commands: [  ]
            });
        };
        if (v instanceof LoadCompleted) {
            var $102 = Steps_Step3_Transition.transitionIsCurrent(state.editor.transitionState)(v.value1);
            if ($102) {
                if (v.value2 instanceof Data_Either.Left) {
                    return new Data_Either.Left(v.value2.value0);
                };
                if (v.value2 instanceof Data_Either.Right) {
                    var loadedState = Steps_Step3_State.applyLoadedEditorState(clearLoadOperation(v.value0)(state))(v.value2.value0);
                    var v1 = Steps_Step3_Transition.latestTransition(loadedState.editor.transitionState);
                    if (v1 instanceof Data_Maybe.Just) {
                        var v2 = Steps_Step3_Transition.finishTransition(loadedState.editor.transitionState)(v1.value0.generation);
                        var settledState = {
                            autofillOperationId: loadedState.autofillOperationId,
                            documentMutationOperationId: loadedState.documentMutationOperationId,
                            loadOperationId: loadedState.loadOperationId,
                            lockOperationId: loadedState.lockOperationId,
                            pendingPostSave: loadedState.pendingPostSave,
                            saveOperationId: loadedState.saveOperationId,
                            editor: {
                                activeSection: loadedState.editor.activeSection,
                                fillState: loadedState.editor.fillState,
                                position: loadedState.editor.position,
                                queue: loadedState.editor.queue,
                                sectionIntent: loadedState.editor.sectionIntent,
                                workQueueCache: loadedState.editor.workQueueCache,
                                workQueueState: loadedState.editor.workQueueState,
                                workQueueUi: loadedState.editor.workQueueUi,
                                transitionState: v2.value1,
                                anchor: Data_Maybe.Nothing.value
                            }
                        };
                        if (v2.value0) {
                            return pure({
                                state: settledState,
                                commands: [ new SyncRoute(v1.value0.historyMode) ]
                            });
                        };
                        return beginPendingTransition(settledState);
                    };
                    if (v1 instanceof Data_Maybe.Nothing) {
                        return pure({
                            state: loadedState,
                            commands: [  ]
                        });
                    };
                    throw new Error("Failed pattern match at Steps.Step3.Update (line 105, column 21 - line 121, column 70): " + [ v1.constructor.name ]);
                };
                throw new Error("Failed pattern match at Steps.Step3.Update (line 101, column 18 - line 121, column 70): " + [ v.value2.constructor.name ]);
            };
            return bind(beginPendingTransition(clearLoadOperation(v.value0)(state)))(function (next) {
                return pure({
                    state: next.state,
                    commands: append([ new MarkSuperseded(v.value0) ])(next.commands)
                });
            });
        };
        if (v instanceof AutofillCompleted && notEq(state.autofillOperationId)(new Data_Maybe.Just(v.value0))) {
            return pure({
                state: state,
                commands: [  ]
            });
        };
        if (v instanceof AutofillCompleted) {
            return bind((function () {
                if (v.value1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(v.value1.value0);
                };
                if (v.value1 instanceof Data_Either.Right) {
                    return Steps_Step3_State.applyAutofillResult(state)(v.value1.value0);
                };
                throw new Error("Failed pattern match at Steps.Step3.Update (line 131, column 22 - line 133, column 55): " + [ v.value1.constructor.name ]);
            })())(function (nextState) {
                return pure({
                    state: {
                        documentMutationOperationId: nextState.documentMutationOperationId,
                        editor: nextState.editor,
                        loadOperationId: nextState.loadOperationId,
                        lockOperationId: nextState.lockOperationId,
                        pendingPostSave: nextState.pendingPostSave,
                        saveOperationId: nextState.saveOperationId,
                        autofillOperationId: clearIfMatches(v.value0)(nextState.autofillOperationId)
                    },
                    commands: [  ]
                });
            });
        };
        if (v instanceof LockCompleted && notEq(state.lockOperationId)(new Data_Maybe.Just(v.value0))) {
            return pure({
                state: state,
                commands: [  ]
            });
        };
        if (v instanceof LockCompleted) {
            if (v.value1 instanceof Data_Either.Left) {
                return new Data_Either.Left(v.value1.value0);
            };
            if (v.value1 instanceof Data_Either.Right) {
                return pure({
                    state: Data_Function.flip(Steps_Step3_State.applyToggleLockResult)(v.value1.value0)({
                        editor: state.editor,
                        saveOperationId: state.saveOperationId,
                        loadOperationId: state.loadOperationId,
                        autofillOperationId: state.autofillOperationId,
                        documentMutationOperationId: state.documentMutationOperationId,
                        pendingPostSave: state.pendingPostSave,
                        lockOperationId: clearIfMatches(v.value0)(state.lockOperationId)
                    }),
                    commands: [  ]
                });
            };
            throw new Error("Failed pattern match at Steps.Step3.Update (line 141, column 9 - line 148, column 22): " + [ v.value1.constructor.name ]);
        };
        if (v instanceof DocumentMutationCompleted && notEq(state.documentMutationOperationId)(new Data_Maybe.Just(v.value0))) {
            return pure({
                state: state,
                commands: [  ]
            });
        };
        if (v instanceof DocumentMutationCompleted) {
            return bind((function () {
                if (v.value1 instanceof Data_Either.Left) {
                    return new Data_Either.Left(v.value1.value0);
                };
                if (v.value1 instanceof Data_Either.Right) {
                    return Steps_Step3_State.applyDocumentMutationResult(state)(v.value1.value0);
                };
                throw new Error("Failed pattern match at Steps.Step3.Update (line 155, column 22 - line 157, column 96): " + [ v.value1.constructor.name ]);
            })())(function (nextState) {
                var clearedState = {
                    autofillOperationId: nextState.autofillOperationId,
                    editor: nextState.editor,
                    loadOperationId: nextState.loadOperationId,
                    lockOperationId: nextState.lockOperationId,
                    pendingPostSave: nextState.pendingPostSave,
                    saveOperationId: nextState.saveOperationId,
                    documentMutationOperationId: clearIfMatches(v.value0)(nextState.documentMutationOperationId)
                };
                if (v.value1 instanceof Data_Either.Right && v.value1.value0 instanceof Steps_Step3_Types.SignatureSigned) {
                    return pure({
                        state: clearedState,
                        commands: [ new StartDocumentMutation(new Steps_Step3_Types.RefreshSignatureGroup(clearedState.editor.fillState.doc.id)) ]
                    });
                };
                return beginPendingTransition(clearedState);
            });
        };
        if (v instanceof ViewEvent && Data_Maybe.isJust(oneOf([ state.saveOperationId, state.loadOperationId, state.documentMutationOperationId ]))) {
            return pure({
                state: captureTransitionDuringBusy(state)(v.value0),
                commands: [  ]
            });
        };
        if (v instanceof ViewEvent && Steps_Step3_State.isBusy(state)) {
            return pure({
                state: state,
                commands: [  ]
            });
        };
        if (v instanceof ViewEvent && (v.value0 instanceof Steps_Step3_Types.WorkQF && v.value0.value0 instanceof Steps_WorkQueue_View.UIStateChange)) {
            return pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: state.saveOperationId,
                    editor: {
                        activeSection: state.editor.activeSection,
                        anchor: state.editor.anchor,
                        fillState: state.editor.fillState,
                        position: state.editor.position,
                        queue: state.editor.queue,
                        sectionIntent: state.editor.sectionIntent,
                        transitionState: state.editor.transitionState,
                        workQueueCache: state.editor.workQueueCache,
                        workQueueState: state.editor.workQueueState,
                        workQueueUi: v.value0.value0.value0
                    }
                },
                commands: [  ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.WorkQueueMetadataF) {
            return pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: state.saveOperationId,
                    editor: {
                        activeSection: state.editor.activeSection,
                        anchor: state.editor.anchor,
                        fillState: state.editor.fillState,
                        position: state.editor.position,
                        queue: state.editor.queue,
                        sectionIntent: state.editor.sectionIntent,
                        transitionState: state.editor.transitionState,
                        workQueueCache: state.editor.workQueueCache,
                        workQueueState: v.value0.value0,
                        workQueueUi: v.value0.value1
                    }
                },
                commands: [ BlockPageUnload.value ]
            });
        };
        if (v instanceof ViewEvent && (v.value0 instanceof Steps_Step3_Types.WorkQF && v.value0.value0 instanceof Steps_WorkQueue_View.JumpToForm)) {
            return requestTransition(state)(lookupTransitionTarget(v.value0.value0.value0.lookup)(v.value0.value0.value0.section)(state));
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.StateF) {
            return pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: state.saveOperationId,
                    editor: {
                        activeSection: state.editor.activeSection,
                        anchor: state.editor.anchor,
                        position: state.editor.position,
                        queue: state.editor.queue,
                        sectionIntent: state.editor.sectionIntent,
                        transitionState: state.editor.transitionState,
                        workQueueCache: state.editor.workQueueCache,
                        workQueueState: state.editor.workQueueState,
                        workQueueUi: state.editor.workQueueUi,
                        fillState: v.value0.value0
                    }
                },
                commands: [ BlockPageUnload.value ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.JumpF) {
            return requestTransition(state)(lookupTransitionTarget(v.value0.value0)(v.value0.value1)(state));
        };
        if (v instanceof ViewEvent && (v.value0 instanceof Steps_Step3_Types.JumpIdxF && (v.value0.value0 < 0 || v.value0.value0 > (length(state.editor.queue) - 1 | 0)))) {
            return pure({
                state: state,
                commands: [  ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.JumpIdxF) {
            return requestTransition(state)(new Data_Maybe.Just({
                idx: v.value0.value0,
                section: v.value0.value1
            }));
        };
        if (v instanceof ViewEvent && (v.value0 instanceof Steps_Step3_Types.NextF && Steps_Step3_Types.onLastItem(state.editor))) {
            var $162 = Steps_Step3_State.shouldSaveCurrentDocument(state);
            if ($162) {
                return pure({
                    state: {
                        autofillOperationId: state.autofillOperationId,
                        documentMutationOperationId: state.documentMutationOperationId,
                        editor: state.editor,
                        loadOperationId: state.loadOperationId,
                        lockOperationId: state.lockOperationId,
                        saveOperationId: state.saveOperationId,
                        pendingPostSave: new Data_Maybe.Just(Steps_Step3_State.SaveThenFinish.value)
                    },
                    commands: [ new StartSave(Data_Maybe.Nothing.value) ]
                });
            };
            return pure({
                state: state,
                commands: [ new Navigate(App_Step.NavNext.value) ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.NextF) {
            return requestTransition(state)(new Data_Maybe.Just({
                idx: state.editor.position + 1 | 0,
                section: Data_Maybe.Nothing.value
            }));
        };
        if (v instanceof ViewEvent && (v.value0 instanceof Steps_Step3_Types.PrevF && state.editor.position <= 0)) {
            return requestTransition(state)(new Data_Maybe.Just({
                idx: length(state.editor.queue) - 1 | 0,
                section: Data_Maybe.Nothing.value
            }));
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.PrevF) {
            return requestTransition(state)(new Data_Maybe.Just({
                idx: state.editor.position - 1 | 0,
                section: Data_Maybe.Nothing.value
            }));
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.SaveF) {
            return pure({
                state: state,
                commands: (function () {
                    var $167 = Steps_Step3_State.shouldSaveCurrentDocument(state);
                    if ($167) {
                        return [ new StartSave(Data_Maybe.Nothing.value) ];
                    };
                    return [  ];
                })()
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.CancelF) {
            return pure({
                state: state,
                commands: [ ConfirmCancel.value ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.SaveCancelF) {
            var $170 = Steps_Step3_State.shouldSaveCurrentDocument(state);
            if ($170) {
                return pure({
                    state: {
                        autofillOperationId: state.autofillOperationId,
                        documentMutationOperationId: state.documentMutationOperationId,
                        editor: state.editor,
                        loadOperationId: state.loadOperationId,
                        lockOperationId: state.lockOperationId,
                        saveOperationId: state.saveOperationId,
                        pendingPostSave: new Data_Maybe.Just(Steps_Step3_State.SaveThenCancel.value)
                    },
                    commands: [ new StartSave(Data_Maybe.Nothing.value) ]
                });
            };
            return pure({
                state: state,
                commands: [ new Navigate(App_Step.NavCancel.value) ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.ExportF) {
            var $172 = Steps_Step3_State.shouldSaveCurrentDocument(state);
            if ($172) {
                return pure({
                    state: {
                        autofillOperationId: state.autofillOperationId,
                        documentMutationOperationId: state.documentMutationOperationId,
                        editor: state.editor,
                        loadOperationId: state.loadOperationId,
                        lockOperationId: state.lockOperationId,
                        saveOperationId: state.saveOperationId,
                        pendingPostSave: new Data_Maybe.Just(new Steps_Step3_State.SaveThenExport(v.value0.value0))
                    },
                    commands: [ new StartSave(Data_Maybe.Nothing.value) ]
                });
            };
            return pure({
                state: state,
                commands: [ new OpenExportUrl(v.value0.value0.url) ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.AutofillF) {
            return pure({
                state: state,
                commands: [ new StartAutofill(API_Autofill.initAutofillArgs(state.editor.fillState.doc.formId)(state.editor.fillState.doc.student.id)) ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.ToggleLockF) {
            var $176 = Data_Maybe.isNothing(state.editor.fillState.doc.locked_at) && Steps_Step3_State.shouldSaveCurrentDocument(state);
            if ($176) {
                return pure({
                    state: {
                        autofillOperationId: state.autofillOperationId,
                        documentMutationOperationId: state.documentMutationOperationId,
                        editor: state.editor,
                        loadOperationId: state.loadOperationId,
                        lockOperationId: state.lockOperationId,
                        saveOperationId: state.saveOperationId,
                        pendingPostSave: new Data_Maybe.Just(Steps_Step3_State.SaveThenLock.value)
                    },
                    commands: [ new StartSave(Data_Maybe.Nothing.value) ]
                });
            };
            return pure({
                state: state,
                commands: [ StartToggleLock.value ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.ActionF) {
            return pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: state.saveOperationId,
                    editor: {
                        activeSection: state.editor.activeSection,
                        anchor: state.editor.anchor,
                        position: state.editor.position,
                        queue: state.editor.queue,
                        sectionIntent: state.editor.sectionIntent,
                        transitionState: state.editor.transitionState,
                        workQueueCache: state.editor.workQueueCache,
                        workQueueState: state.editor.workQueueState,
                        workQueueUi: state.editor.workQueueUi,
                        fillState: v.value0.value1
                    }
                },
                commands: [ new StartAutofill(v.value0.value0.value0) ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.DocumentMutationF) {
            return pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: state.saveOperationId,
                    editor: {
                        activeSection: state.editor.activeSection,
                        anchor: state.editor.anchor,
                        position: state.editor.position,
                        queue: state.editor.queue,
                        sectionIntent: state.editor.sectionIntent,
                        transitionState: state.editor.transitionState,
                        workQueueCache: state.editor.workQueueCache,
                        workQueueState: state.editor.workQueueState,
                        workQueueUi: state.editor.workQueueUi,
                        fillState: v.value0.value0
                    }
                },
                commands: [ new StartDocumentMutation(v.value0.value1) ]
            });
        };
        if (v instanceof ViewEvent && v.value0 instanceof Steps_Step3_Types.ScrollF) {
            return pure({
                state: Steps_Step3_State.mapEditorState(function (editor) {
                    return {
                        queue: editor.queue,
                        position: editor.position,
                        activeSection: editor.activeSection,
                        sectionIntent: editor.sectionIntent,
                        transitionState: editor.transitionState,
                        workQueueState: editor.workQueueState,
                        workQueueUi: editor.workQueueUi,
                        workQueueCache: editor.workQueueCache,
                        fillState: editor.fillState,
                        anchor: Data_Maybe.Nothing.value
                    };
                })(state),
                commands: [  ]
            });
        };
        throw new Error("Failed pattern match at Steps.Step3.Update (line 61, column 16 - line 317, column 14): " + [ v.constructor.name ]);
    };
};
var applyStartedCommand = function (state) {
    return function (command) {
        return function (opId) {
            if (command instanceof StartSave) {
                return {
                    editor: state.editor,
                    loadOperationId: state.loadOperationId,
                    autofillOperationId: state.autofillOperationId,
                    lockOperationId: state.lockOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: new Data_Maybe.Just(opId)
                };
            };
            if (command instanceof StartLoad) {
                var v = Steps_Step3_State.setPendingLoadTarget(command.value0)(state);
                return {
                    editor: v.editor,
                    saveOperationId: v.saveOperationId,
                    autofillOperationId: v.autofillOperationId,
                    lockOperationId: v.lockOperationId,
                    documentMutationOperationId: v.documentMutationOperationId,
                    pendingPostSave: v.pendingPostSave,
                    loadOperationId: new Data_Maybe.Just(opId)
                };
            };
            if (command instanceof StartAutofill) {
                return {
                    editor: state.editor,
                    saveOperationId: state.saveOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    pendingPostSave: state.pendingPostSave,
                    autofillOperationId: new Data_Maybe.Just(opId)
                };
            };
            if (command instanceof StartToggleLock) {
                return {
                    editor: state.editor,
                    saveOperationId: state.saveOperationId,
                    loadOperationId: state.loadOperationId,
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    pendingPostSave: state.pendingPostSave,
                    lockOperationId: new Data_Maybe.Just(opId)
                };
            };
            if (command instanceof StartDocumentMutation) {
                return {
                    editor: state.editor,
                    saveOperationId: state.saveOperationId,
                    loadOperationId: state.loadOperationId,
                    autofillOperationId: state.autofillOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    documentMutationOperationId: new Data_Maybe.Just(opId)
                };
            };
            return state;
        };
    };
};
export {
    ViewEvent,
    ConfirmCancelResult,
    SaveCompleted,
    LoadCompleted,
    AutofillCompleted,
    LockCompleted,
    DocumentMutationCompleted,
    SyncRoute,
    StartSave,
    StartLoad,
    StartAutofill,
    StartToggleLock,
    StartDocumentMutation,
    ConfirmCancel,
    AllowPageUnload,
    BlockPageUnload,
    OpenExportUrl,
    Navigate,
    MarkSuperseded,
    update,
    applyStartedCommand
};
//# sourceMappingURL=index.js.map
